import { type FC } from "react";
import { useParams } from "react-router-dom";
import {
    useGetWorkflow,
    useGetWorkflowExecution,
    useListWorkflowExecutionActions,
    useListWorkflowExecutionOutputs,
} from "@/queries/automation-queries";
import { ErrorMessage } from "@/components/ErrorMessage";
import { WorkflowExecutionSummary } from "@/components/automations/AutomationExecutionSummary";
import { WorkflowExecutionPerformanceChart } from "@/components/automations/AutomationExecutionPerformanceChart";
import { WorkflowExecutionOutputsTable } from "@/components/automations/WorkflowExecutionOutputsTable";
import { Banner } from "@/components/flexkit/Banner";

export const AutomationExecutionSummaryPage: FC = () => {
    const { workflowExecutionId } = useParams<{ workflowExecutionId: string }>();
    const { data: workflowExecution, error: workflowExecutionError } = useGetWorkflowExecution(workflowExecutionId);
    const { data: workflow } = useGetWorkflow(workflowExecution?.metadata?.workflowId);
    const { data: actions } = useListWorkflowExecutionActions({
        enabled: !!workflowExecutionId,
        workflowExecutionId: workflowExecutionId || "",
    });
    const { data: outputs } = useListWorkflowExecutionOutputs({
        enabled: !!workflowExecutionId,
        workflowExecutionId: workflowExecutionId || "",
    });

    return (
        <div data-testid="workflow-execution-summary" className="flex size-full flex-col gap-4">
            <ErrorMessage error={workflowExecutionError} />
            {workflowExecution?.status?.failureMessage && (
                <Banner variant="danger" text={workflowExecution.status.failureMessage} />
            )}
            {workflowExecution && <WorkflowExecutionSummary workflowExecution={workflowExecution} />}
            {workflowExecution && actions && (
                <WorkflowExecutionPerformanceChart workflow={workflow} actions={actions} />
            )}
            {actions && workflow && workflowExecutionId && (
                <WorkflowExecutionOutputsTable
                    outputs={outputs || []}
                    actions={actions}
                    workflow={workflow}
                    workflowExecutionId={workflowExecutionId}
                />
            )}
        </div>
    );
};
